// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3PINt","messages":"Chat_messages__2BXmM","dateDivider":"Chat_dateDivider__168pb"};